import type { FilePathTuple, FilenamesStorage } from "@app-types/storage.types";

/**
 * Type guard for FilePathTuple
 */
export function isFilePathTuple(data: unknown): data is FilePathTuple {
  return (
    Array.isArray(data) &&
    data.length === 2 &&
    typeof data[0] === "string" &&
    typeof data[1] === "string"
  );
}

/**
 * Type guard for FilenamesStorage
 */
export function isFilenamesStorage(data: unknown): data is FilenamesStorage {
  if (typeof data !== "object" || data === null) return false;

  return Object.values(data as Record<string, unknown>).every(
    (value) =>
      Array.isArray(value) && value.every((item) => isFilePathTuple(item))
  );
}
